<template>
  <v-badge
    overlap
    :color="badgeColor"
    :offset-x="scaledBadgeOffsetX"
    :offset-y="scaledBadgeOffsetY"
    class="renew-badge"
  >
    <template v-slot:badge>
      <div class="badge-content">
        {{ badgeText }}
      </div>
    </template>

    <v-btn
      :color="buttonColor"
      depressed
      rounded
      class="renew-button white--text rounded-lg button"
      :class="{ 'btn-loading': loading }"
      @click="!loading && $emit('click')"
    >
      <v-avatar
        :style="{
          width: scaledAvatarSize,
          height: scaledAvatarSize,
          minWidth: scaledAvatarSize,
        }"
      >
        <v-icon
          class="refresh-icon"
          :class="{ 'spin-animation': loading }"
          :style="{ fontSize: `calc(${scaledAvatarSize} * 0.8)` }"
        >
          {{ icon }}
        </v-icon>
      </v-avatar>
      <span class="mr-3" style="font-weight: bold">{{ buttonText }}</span>
    </v-btn>
  </v-badge>
</template>

<script>
export default {
  name: "RenewButton",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    badgeText: {
      type: String,
      required: true,
    },
    badgeColor: {
      type: String,
      default: "red",
    },
    buttonColor: {
      type: String,
      default: "red",
    },
    buttonText: {
      type: String,
      default: "تمدید",
    },
    icon: {
      type: String,
      default: "mdi-autorenew",
    },
    badgeRotation: {
      type: Number,
      default: -12,
    },
    badgeBorderWidth: {
      type: Number,
      default: 1,
    },
    badgeBorderRadius: {
      type: Number,
      default: 8,
    },
    badgeOffsetX: {
      type: Number,
      default: 68,
    },
    badgeOffsetY: {
      type: Number,
      default: 15,
    },
    badgeShadow: {
      type: Boolean,
      default: true,
    },
    scale: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    scaledFontSize() {
      return `${1.3 * this.scale}rem`;
    },
    scaledAvatarSize() {
      return `${25 * this.scale}px`;
    },
    scaledPadding() {
      return `${5 * this.scale}px ${20 * this.scale}px`;
    },
    scaledBadgeFontSize() {
      return `${12 * this.scale}px`;
    },
    scaledBadgePadding() {
      return `${6 * this.scale}px ${14 * this.scale}px`;
    },
    scaledBadgeOffsetX() {
      return this.badgeOffsetX * this.scale;
    },
    scaledBadgeOffsetY() {
      return this.badgeOffsetY * this.scale;
    },
  },
};
</script>

<style scoped>
.renew-button {
  width: 100% !important;
  font-size: v-bind(scaledFontSize) !important;
  font-weight: 500;
  padding: v-bind(scaledPadding) !important;
}

.badge-content {
  color: white;
  font-size: v-bind(scaledBadgeFontSize) !important;
  font-weight: bold;
  white-space: nowrap;
  line-height: 1.2;
  z-index: 2;
}

.renew-badge ::v-deep .v-badge__badge {
  height: auto !important;
  min-width: auto !important;
  padding: v-bind(scaledBadgePadding) !important;
  border: v-bind('badgeBorderWidth + "px solid #47434380"') !important;
  border-radius: v-bind('badgeBorderRadius + "px"') !important;
  transform: v-bind("`rotate(${badgeRotation}deg)`") !important;
  /* box-shadow: v-bind(
    'badgeShadow ? "0 10px 8px rgba(0,0,0,0.3)" : "none"'
  ) !important; */
   z-index: 3;
}

.v-avatar {
  background: linear-gradient(180deg, #ffffff40 0%, #00000030 100%) !important;
  /* box-shadow: inset 0 3px 6px rgba(255, 255, 255, 0.4),
    inset 0 -3px 6px rgba(0, 0, 0, 0.4), 0 4px 10px rgba(0, 0, 0, 0.4) !important;*/
  position: relative;
  overflow: hidden;
  border: 1.5px solid rgba(255, 255, 255, 0.4);
  border-radius: 8px !important;
  padding: 1px !important;
  margin: 0 !important;
}

.v-avatar::before {
  content: "";
  position: absolute;
  top: -20%;
  left: -20%;
  width: 80%;
  height: 80%;
  background: radial-gradient(
    circle at 30% 30%,
    rgba(255, 255, 255, 0.6),
    transparent 70%
  );
  border-radius: 8px;
  pointer-events: none;
  filter: blur(2px);
}

.refresh-icon {
  color: white !important;
}
.full-width-btn {
  width: 100% !important;
}

.full-width-btn >>> .v-btn {
  width: 100% !important;
}

.full-width-btn >>> .renew-button {
  width: 100% !important;
}
.spin-animation {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.renew-button.loading {
  pointer-events: none;
  opacity: 0.8;
}
.btn-loading {
  pointer-events: none !important;
  opacity: 0.65 !important;
  cursor: not-allowed !important;
}

.btn-loading.v-btn--disabled {
  background-color: inherit !important;
  color: white !important;
}

.spin-animation {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.renew-button {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px;
}

.renew-button:hover,
.renew-badge:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2) !important;
}

.renew-badge ::v-deep .v-badge__badge {
  font-weight: bold !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1) !important;
}
</style>
